import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Link } from "react-router-dom";

/**
 * SelectPaymentMethod component displays options for finding UPI ID on different payment apps.
 * Renders clickable cards for each app and navigation to instructions.
 */
const SelectPaymentMethod = ({ login = null }) => {
  const [paymnet] = useState([
    { image: './images/bhim.png', 'link': '', class: "w-65px" },
    { image: './images/gpay.png', 'link': '', class: "w-60px" },
    { image: './images/amazon.png', 'link': '', class: "w-75px" },
    { image: './images/paytm.png', 'link': '', class: "w-60px" },
    { image: './images/phonepe.png', 'link': '', class: "w-75px" },

  ])

  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12">
            <h4 className="mb-5">
              How To Find My UPI ID On Different UPI Apps ?
            </h4>
            <p className="grey-text">
              Click on the below options to find your UPI ID
            </p>
          </div>

          <div className="col-md-12">
            {paymnet.map((dataimage, index) => (
              <div style={{ border: '1px solid #f0f0f0' }} className="card mb-3">
                <div className="card-body p-5">
                  <Link to={dataimage.link}>
                    <div className="d-flex rounded border-2 border-color-dark align-items-center justify-content-between">
                      <img
                        className={dataimage.class}
                        alt="payment upi"

                        src={toAbsoluteUrl(`/media/${dataimage.image}`)}
                      />
                      <img
                        className="w-25px h-8px"
                        alt="arrow"
                        src={toAbsoluteUrl("/media/images/right-arrow.png")}
                      />
                    </div>
                  </Link>
                </div>
              </div>
            ))}



            <div className="select-upi">
              <Link to={`customer/how-to-find-upi`}>
                <h5 className="mb-0">Other UPI Id's</h5>
              </Link>
              <img
                width="25"
                alt="arrow"
                src={toAbsoluteUrl("/media/images/right-arrow.png")}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectPaymentMethod;
